/**
 * Avisa quando um elemento muda de tamanho. Devolve a função que desfaz a observação.
 *
 * O tabuleiro do Kanban e o diagrama de classes precisam disto pelo mesmo motivo: os
 * dois vivem também dentro de um modal, onde o tamanho da JANELA não diz nada sobre o
 * espaço que eles têm — e o do diagrama encolhe até quando a gaveta de navegação abre,
 * sem janela nenhuma ser redimensionada. Os dois tinham cópia própria deste bloco.
 *
 * A medição vai para o QUADRO SEGUINTE, e não para dentro da entrega do ResizeObserver.
 * Quem mede aqui mexe no layout com o que mediu — o tabuleiro escolhe entre faixas lado
 * a lado e empilhadas, o diagrama traz as caixas de volta para dentro da viewport — e
 * mexer no layout durante a entrega faz a rodada não fechar no mesmo quadro. O navegador
 * reclama disso com "ResizeObserver loop completed with undelivered notifications", que
 * é o que aparecia ao girar o celular no Kanban. Adiando um quadro, cada medição cai numa
 * rodada nova e a anterior fecha em paz.
 *
 * Onde não houver ResizeObserver sobra o resize da janela: pega menos casos, mas é o que
 * dá para fazer.
 */
export function watchSize(element: Element, onResize: () => void): () => void {
    let frame = 0
    //Uma medição por quadro: girar a tela dispara a entrega várias vezes seguidas
    const schedule = () => {
        cancelAnimationFrame(frame)
        frame = requestAnimationFrame(onResize)
    }

    if (typeof ResizeObserver === 'undefined') {
        window.addEventListener('resize', schedule)
        return () => {
            cancelAnimationFrame(frame)
            window.removeEventListener('resize', schedule)
        }
    }

    const observer = new ResizeObserver(schedule)
    observer.observe(element)
    return () => {
        cancelAnimationFrame(frame)
        observer.disconnect()
    }
}
